import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { WebsiteState } from '@gift/website-state/store';

const { actions, reducer } = createSlice({
    name: 'meta',
    initialState: {} as {
        [key: string]: any
    },
    reducers: {
        updateMetaItem: (state, action: PayloadAction<{ key: string, value: any }>) => ({
            ...state,
            [action.payload.key]: action.payload.value
        })
    }
});

export const createMetaBindings = <TMeta>() => ({

    createMetaSelector: <T>(selector: (meta: TMeta) => T) => createSelector(
        (state: WebsiteState) => state.meta as TMeta,
        o => selector(o)),

    /**
     * NOTE: Any item set on the meta will be visible to tenants via the output API.
     */
    createMetaUpdateAction: <TKey extends keyof TMeta & string>(key: TKey) =>
        (value: TMeta[TKey]) => actions.updateMetaItem({ key, value })
});

export { reducer };